import { Component, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import { AdminCaseTableItem } from 'src/app/components/dashboard/cases/cases.component';
import { CasesService } from 'src/app/services/cases/cases.service';
import {
  Product,
  ProductService,
} from 'src/app/services/product-service/product-service.service';
import { PayeePopupComponent } from '../../shared/payee-popup/payee-popup.component';
import { PayeeInfoComponent } from '../../shared/payee-info/payee-info.component';
import { PayeeFormFieldComponent } from '../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeAutocompleteComponent } from '../../shared/payee-form-fields/payee-autocomplete/payee-autocomplete.component';
import { PayeeButtonComponent } from '../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-copy-case-with-product-dialog',
  templateUrl: './copy-case-with-product-dialog.component.html',
  styleUrls: ['./copy-case-with-product-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeInfoComponent,
    PayeeFormFieldComponent,
    PayeeAutocompleteComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeButtonComponent,
    MatDialogClose,
  ],
})
export class CopyCaseWithProductDialogComponent implements OnInit {
  private data = inject<AdminCaseTableItem>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<MatDialogRef<CopyCaseWithProductDialogComponent>>(MatDialogRef);
  private fb = inject(FormBuilder);
  private casesService = inject(CasesService);
  private products = inject(ProductService);

  readonly productControl: FormControl<Product | null>;
  productOptions: Product[] = [];
  loading = false;

  constructor() {
    this.productControl = this.fb.control<Product | null>(null, [
      Validators.required,
    ]);
  }

  async ngOnInit(): Promise<void> {
    const result = await this.products.getProducts({
      client_country_iso: this.data.jurisdiction,
      debtor_country_iso: this.data.jurisdiction,
    });
    this.productOptions = result.products.filter((p) => p.type !== 'hard_2');
  }

  async submit(): Promise<void> {
    if (this.productControl.invalid) {
      this.productControl.markAsDirty();
      return;
    }

    try {
      this.loading = true;
      const product: Product = this.productControl.value!;
      const result = await this.casesService.copyCaseWithProduct(
        this.data.id,
        product.id,
      );
      this.dialogRef.close(result);
    } catch (error) {
      this.loading = false;
      console.error('Error while copying case', error);
    }
  }

  productDisplayWith(p?: Product): string {
    return p?.name ?? '';
  }
}
